import React from 'react';
import Radium from 'radium';
import Modal from 'react-responsive-modal';
import {Button} from 'views/AppElements';
import {Input, SubmitButton, RGForm, TextArea, RadioButton} from 'views/FormElements';
import {Separator} from 'views/AppElements';
import { Formik } from 'formik';
import Yup from 'yup';
import HttpService from 'service/HttpService';
import AppUtil from 'AppUtil';

const MIN_WITHDRAWAL_AMOUNT = 2000;

const Form = ({isSubmitting, values}) => {
	let submitBtn = "Submit";
		
	if(isSubmitting === true)
		submitBtn = <span>Submitting <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;
	
	return <RGForm>
			<Separator style={{margin: '20px auto', width: '30%'}} />
			<Input name="amount" type="text" disabled={true} label="Amount: Rs." 
					value={values.amount} style={{marginBottom: "0px"}} /> 

			<div style={{marginBottom: '10px'}}>
				<label>Select Payment Method:</label>
				<div className='flexRow' style={{marginBottom: '0px'}} id="joinAsRadioBtnGroup">
					<RadioButton style={{flexGrow: '1'}} name="paymentVia" value={"eSewa"} 
										label={<span style={{color: '#596161'}}>eSewa </span>} 
										checked={values.paymentVia === "eSewa"} />

					<RadioButton style={{flexGrow: '1'}} name="paymentVia" value={"bank"} 
									label={<span style={{color: '#596161'}}>Bank Transfer</span>} 
									checked={values.paymentVia === "bank"} />
				</div>
			</div>
            {
                values.paymentVia === "eSewa" &&
                <Input name="esewaId" type="number" label="eSewa Id (10 digit):" placeholder="E.g. 9862441133" style={{marginBottom: "0px"}} />   
            }

            {
                values.paymentVia === "bank" &&
                <React.Fragment>
					<div style={{margin: '0 0 20px 0', color: 'gray', fontWeight: 'bold'}}>
						Note: Bank Transfer charges will be deducted from the requested amount.
					</div>
                    <Input name="bankAccountNo" type="text" label="Account No: " style={{marginBottom: "0px", marginTop: "10px"}}/>
                    <Input name="bankAccountName" type="text" label="Account Name: " style={{marginBottom: "0px", marginTop: "10px"}}/>
                    <Input name="bankName" type="text" label="Bank Name" style={{marginBottom: "0px"}} />   
                    <Input name="bankBranch" type="text" label="Bank Branch" style={{marginBottom: "0px"}} />   
                </React.Fragment>
            }
			
			
			<SubmitButton style={{marginTop: "10px"}} color="primary" disabled={isSubmitting}>
				{submitBtn}
			</SubmitButton>
	</RGForm>
};

class PaymentModal extends React.Component {
    constructor(props) {
		super(props);
		this.INIT_VALUES = {paymentVia: '', esewaId: '', 
                            bankAccountNo: '', bankAccountName: '', 
                            bankName: '', bankBranch: '',
							amount: this.props.currentBalance
							};

		this.handleFormSubmission = this.handleFormSubmission.bind(this);
	}

    validationScheme() {
		return Yup.object().shape({
			amount: Yup.number().min(MIN_WITHDRAWAL_AMOUNT, 'Min withdrawal amount is Rs. '+AppUtil.formatNumber(MIN_WITHDRAWAL_AMOUNT)),
			paymentVia: Yup.string().required('Select your payment method'),
			esewaId: Yup.string().when(['paymentVia'], (paymentVia, schema) => {
				if(paymentVia === 'eSewa')
					return Yup.string().required('Provide your eSewa Id');

				return Yup.string();
			}),
			bankAccountNo: Yup.string().when(['paymentVia'], (paymentVia, schema) => {
				if(paymentVia === 'bank')
					return Yup.string().required('Enter your Account No.');

				return Yup.string();
			}),
			bankAccountName: Yup.string().when(['paymentVia'], (paymentVia, schema) => {
				if(paymentVia === 'bank')
					return Yup.string().required('Enter your Account Name');

				return Yup.string();
			}),
			bankName: Yup.string().when(['paymentVia'], (paymentVia, schema) => {
				if(paymentVia === 'bank')
					return Yup.string().required('Enter your Bank Name');

				return Yup.string();
			}),
			bankBranch: Yup.string().when(['paymentVia'], (paymentVia, schema) => {
				if(paymentVia === 'bank')
					return Yup.string().required('Enter your Bank Branch');

				return Yup.string();
			})
		});
	}

	handleFormSubmission(values, {setSubmitting, resetForm}) {
        const sendToDetail = {};

		if(values.paymentVia === "eSewa") {
			sendToDetail["eSewa"] = values.esewaId;
		} else if (values.paymentVia === "bank") {
			sendToDetail["Bank Account No"] = values.bankAccountNo;
			sendToDetail["Bank Account Name"] = values.bankAccountName;
			sendToDetail["Bank Name"] = values.bankName;
			sendToDetail["Bank Branch"] = values.bankBranch;
		}
        const confirmRest = confirm("Are you sure you want to withdraw Rs. "+this.props.currentBalance+" amount?");

		if(confirmRest === true) {
			const targetIds = this.props.productStats
									.filter(t => t.targetAchieved >= t.currentTarget.salesTarget)
									.map(t => t.currentTarget.id);
						HttpService.redeem(targetIds, sendToDetail, function(success) {
                            setSubmitting(false);

							//on success, reload cashable targets and redeem history
							if(success) {
                                HttpService.getDesignerBalance();
                                resetForm(this.INIT_VALUES);
								this.props.onClose();
							}
						}.bind(this));
		} else {
            setSubmitting(false);
        }
	}


    render() {
        const {open, onClose} = this.props;
        return <Modal closeOnOverlayClick={false} open={open} onClose={onClose}
				classNames={{ modal: 'withdraw-payment-modal', closeIcon: 'withdraw-payment-close-icon' }}>
            <div>
                <h2>Send Withdraw Request</h2>
				<div style={{margin: '0 0 20px 0', color: 'orange', fontSize: '90%'}}>
					Your amount will be transferred within 7 days of request.
				</div>

                <Formik initialValues={this.INIT_VALUES} onSubmit={this.handleFormSubmission}
						validationSchema={this.validationScheme} component={Form} />
            </div>
        </Modal>
    };
	
}

export default PaymentModal;



// WEBPACK FOOTER //
// ./src/views/designer/PaymentModal.js